import React from 'react'
import PropTypes from 'prop-types'

const justifyMap = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
}

const Tabs = ({ tabs = [], activeTab, onTabChange, justify = 'center' }) => {
  return (
    <div className={`flex items-center ${justifyMap[justify] || 'justify-center'}`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`px-4 py-2 transition-all duration-200 ${
            activeTab === tab.id
              ? 'font-semibold p-3 text-primary border-b border-primary focus:ring-0'
              : 'shadow-transparent text-gray-700 font-semibold no-underline outline-none'
          }`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default Tabs

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  justify: PropTypes.oneOf(['start', 'center', 'end', 'between', 'around', 'evenly']),
}
